// Copyright (c) Move Closer 2022.

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
export const OrderListConfig = {
  ordersPerPage: 5,
  totalVisiblePaginationElements: 5
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const ORDERS_LIST_ITEM_COMPONENT_KEY = 'OrdersListItemComponent'

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export enum OrdersListItemLayout {
  Default = 'default',
  Basic = 'basic'
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export interface OrdersListItemConfig {
  /**
   * Number of days when user can retry payment (counting from purchase date)
   */
  daysForPaymentRetry: number
  layout: string
  returnOrderBtnVariant: string
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const ORDERS_LIST_ITEM_COMPONENT_CONFIG_MAP: OrdersListItemConfig = {
  daysForPaymentRetry: 7,
  layout: 'default',
  returnOrderBtnVariant: 'outline'
}
